import LoaderBasket from '../components/loader/Basket.vue';
import LoaderShare from '../components/loader/Share';
import Creator from '@/components/Creator';
import { DEFAULT_PRODUCT } from '../../utils/configure-environment';

export default [
  {
    path: '/:articleNumber',
    name: 'root',
    component: Creator
  },
  {
    path: '/',
    redirect: '/' + DEFAULT_PRODUCT
  },
  {
    path: '',
    redirect: '/' + DEFAULT_PRODUCT
  },
  {
    path: '/load/basket/:basketItemId',
    name: 'loader-basket',
    component: LoaderBasket
  },
  {
    path: '/load/share/:uuid',
    name: 'loader-shared-composition',
    component: LoaderShare
  }
];
